var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreditMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.99992V4.66659H2.99992C2.55789 4.66659 2.13397 4.49099 1.82141 4.17843C1.50885 3.86587 1.33325 3.44195 1.33325 2.99992M1.33325 2.99992C1.33325 2.08325 2.08325 1.33325 2.99992 1.33325H12.9999V4.66659M1.33325 2.99992V12.9999C1.33325 13.9166 2.08325 14.6666 2.99992 14.6666H14.6666V11.3333M12.9999 7.99992C12.5579 7.99992 12.134 8.17551 11.8214 8.48807C11.5088 8.80064 11.3333 9.22456 11.3333 9.66659C11.3333 10.5833 12.0833 11.3333 12.9999 11.3333H16.3333V7.99992H12.9999Z",
    stroke: "#1A1D20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditMenu);
export default __webpack_public_path__ + "static/media/icon-credit-menu.acad3ca2554812453d6ed67bdb8d059c.svg";
export { ForwardRef as ReactComponent };